import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import Call from '@xsite-ui/common.icons/call';
import React, { forwardRef } from 'react';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import styled from '@emotion/styled';
import { Flex, Box } from '@xsite-ui/common.elements';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var Container = styled(Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex-direction: column;\n  width: 100%;\n"])));
var PhoneLinkWrapper = styled(Flex)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  .phone-link-text {\n    display: ", ";\n  }\n  @media (min-width: ", ") {\n    .phone-link-text {\n      display: block;\n    }\n  }\n\n  @media (hover: hover) {\n    '&:hover': {\n      text-decoration: ", ";\n    }\n  }\n\n  ", ";\n"])), function (_ref) {
  var withSecondaryCta = _ref.withSecondaryCta;
  return withSecondaryCta ? 'none' : 'block';
}, function (_ref2) {
  var _theme$breakpoints;

  var theme = _ref2.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$breakpoints = theme.breakpoints) === null || _theme$breakpoints === void 0 ? void 0 : _theme$breakpoints[1];
}, function (_ref3) {
  var _theme$variants, _theme$variants$phone;

  var theme = _ref3.theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$variants = theme.variants) === null || _theme$variants === void 0 ? void 0 : (_theme$variants$phone = _theme$variants.phoneLink) === null || _theme$variants$phone === void 0 ? void 0 : _theme$variants$phone.decorationHover) || 'none';
}, function (_ref4) {
  var _theme$variants2, _theme$variants2$phon, _theme$variants3, _theme$variants3$phon, _theme$variants4, _theme$variants4$phon;

  var theme = _ref4.theme;
  return {
    textDecoration: (theme === null || theme === void 0 ? void 0 : (_theme$variants2 = theme.variants) === null || _theme$variants2 === void 0 ? void 0 : (_theme$variants2$phon = _theme$variants2.phoneLink) === null || _theme$variants2$phon === void 0 ? void 0 : _theme$variants2$phon.decoration) || 'none',
    transition: (theme === null || theme === void 0 ? void 0 : (_theme$variants3 = theme.variants) === null || _theme$variants3 === void 0 ? void 0 : (_theme$variants3$phon = _theme$variants3.phoneLink) === null || _theme$variants3$phon === void 0 ? void 0 : _theme$variants3$phon.transition) || 'all 0.3s ease',
    '&:hover': {
      textDecoration: (theme === null || theme === void 0 ? void 0 : (_theme$variants4 = theme.variants) === null || _theme$variants4 === void 0 ? void 0 : (_theme$variants4$phon = _theme$variants4.phoneLink) === null || _theme$variants4$phon === void 0 ? void 0 : _theme$variants4$phon.decorationHover) || 'none'
    },
    alignItems: 'center'
  };
});
var PhoneCTATextContainer = styled(Box)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: block;\n  font-size: ", "px;\n  font-weight: ", ";\n  @media (min-width: ", ") {\n    display: none;\n  }\n"])), function (_ref5) {
  var _theme$fontSizes;

  var theme = _ref5.theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$fontSizes = theme.fontSizes) === null || _theme$fontSizes === void 0 ? void 0 : _theme$fontSizes[2]) || 16;
}, function (_ref6) {
  var _theme$fontWeights;

  var theme = _ref6.theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$fontWeights = theme.fontWeights) === null || _theme$fontWeights === void 0 ? void 0 : _theme$fontWeights[1]) || 600;
}, function (_ref7) {
  var _theme$breakpoints2;

  var theme = _ref7.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$breakpoints2 = theme.breakpoints) === null || _theme$breakpoints2 === void 0 ? void 0 : _theme$breakpoints2[1];
});
var SecondaryPhoneLink = styled(Box)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: block;\n  font-size: ", "px;\n  color: ", ";\n  margin-top: ", "px;\n  text-align: center;\n  font-weight: ", ";\n  @media (min-width: ", ") {\n    display: none;\n  }\n"])), function (_ref8) {
  var _theme$fontSizes2;

  var theme = _ref8.theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$fontSizes2 = theme.fontSizes) === null || _theme$fontSizes2 === void 0 ? void 0 : _theme$fontSizes2[0]) || 12;
}, function (_ref9) {
  var _theme$colors, _theme$colors$graysca;

  var theme = _ref9.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : (_theme$colors$graysca = _theme$colors.grayscale) === null || _theme$colors$graysca === void 0 ? void 0 : _theme$colors$graysca[4];
}, function (_ref10) {
  var _theme$space;

  var theme = _ref10.theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$space = theme.space) === null || _theme$space === void 0 ? void 0 : _theme$space[2]) || 8;
}, function (_ref11) {
  var _theme$fontWeights2;

  var theme = _ref11.theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$fontWeights2 = theme.fontWeights) === null || _theme$fontWeights2 === void 0 ? void 0 : _theme$fontWeights2.semiBold) || 600;
}, function (_ref12) {
  var _theme$breakpoints3;

  var theme = _ref12.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$breakpoints3 = theme.breakpoints) === null || _theme$breakpoints3 === void 0 ? void 0 : _theme$breakpoints3[1];
});
PhoneLinkWrapper.defaultProps = {
  variant: 'primary'
};

var _excluded = ["formattedValue", "phoneNumber", "show", "showPhoneIcon", "target", "withSecondaryCta", "phoneCta", "blrs", "productPosition"];
var PhoneLink = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var formattedValue = _ref.formattedValue,
      phoneNumber = _ref.phoneNumber,
      _ref$show = _ref.show,
      show = _ref$show === void 0 ? true : _ref$show,
      _ref$showPhoneIcon = _ref.showPhoneIcon,
      showPhoneIcon = _ref$showPhoneIcon === void 0 ? true : _ref$showPhoneIcon,
      _ref$target = _ref.target,
      target = _ref$target === void 0 ? '_blank' : _ref$target,
      _ref$withSecondaryCta = _ref.withSecondaryCta,
      withSecondaryCta = _ref$withSecondaryCta === void 0 ? false : _ref$withSecondaryCta,
      phoneCta = _ref.phoneCta,
      blrs = _ref.blrs,
      productPosition = _ref.productPosition,
      restProps = _objectWithoutProperties(_ref, _excluded);

  if (!show) {
    return null;
  }

  var phoneFormat = '$1-$2-$3';
  var regex = /(\d{3})(\d{3})(\d{4})/;
  var phoneNumberToDisplay = formattedValue ? formattedValue.replace(regex, phoneFormat) : phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.toString().replace(regex, phoneFormat);
  var phoneProps = {
    'data-phone': phoneNumber,
    'data-role-id': 'phone-link',
    'data-role': 'phone-call',
    'data-href': "tel:1".concat(phoneNumber),
    href: "tel:+1".concat(phoneNumber),
    'data-phone-origin': formattedValue,
    'data-blrs': "".concat(blrs),
    'data-position': "".concat(productPosition)
  };
  var ComponentWrapper = withSecondaryCta ? Container : React.Fragment;
  var classNameProps = withSecondaryCta ? {
    className: 'with-secondary-cta-wrapper'
  } : {};
  return /*#__PURE__*/React.createElement(ComponentWrapper, classNameProps, /*#__PURE__*/React.createElement(PhoneLinkWrapper, _extends({
    ref: ref,
    tx: "phoneLink",
    target: target,
    as: "a",
    withIcon: showPhoneIcon,
    withSecondaryCta: withSecondaryCta,
    "data-testid": "phone-link"
  }, phoneProps, restProps), showPhoneIcon && /*#__PURE__*/React.createElement(Call, {
    className: "phone-link-icon"
  }), withSecondaryCta && /*#__PURE__*/React.createElement(PhoneCTATextContainer, {
    as: "span",
    "data-testid": "phone-cta"
  }, phoneCta), /*#__PURE__*/React.createElement("span", {
    className: "phone-link-text"
  }, phoneNumberToDisplay)), withSecondaryCta && /*#__PURE__*/React.createElement(SecondaryPhoneLink, {
    as: "span",
    className: "phone-link-text",
    "data-testid": "secondary-phone-link"
  }, phoneNumberToDisplay));
});

export { PhoneLink as default };
